
		$(function() {
		var slides = [];
		var slides1 = [];
		$('#mn > div:has(input[name="slideshow1"])')
		.each( function() {
		var $div = $( this );
		//alert($div.attr);
		var num1 = parseInt( $div.find( 'input[name="slideshow1"]' ).val() );
		slides1.push( {
			div: $div,
			backgrounds: parseInt( $div.find( 'input[name="slideshow1"]' ).val() )
		} );
		} )
		$( '#home-slides > li:has(input[name="slideshow"])' )
		.removeClass( 'selected' )
		.each( function() {
		var $li = $( this );
		var num = parseInt( $li.find( 'input[name="slideshow"]' ).val() );
		slides.push( {
			li: $li,
			content: $li.children( '.content' ).eq( 0 )
		} );
		} )
		.eq( 0 )
		.addClass( 'selected' );
		if( slides.length > 0 ) {
		var timeout = null;
		var delay = 8000;
		var fadeDuration = 1000;
		var currentSlide = slides[0];

		var stopAnimation = function() {
			if( timeout ) clearTimeout( timeout );
			timeout = null;
			$.each( slides, function() { this.content.stop( true, true ).css( { 'z-index': 1 } ); } );
		};

		var showSlide = function( num, bg ) {
			stopAnimation();			
			var previousSlide = currentSlide;
			//previousSlide.content.closest( 'ul' ).removeClass();
			previousSlide.li.removeClass( 'selected' );
			currentSlide = slides[ num - 1 ];
			currentSlide.content.closest( 'ul' ).removeClass().addClass( 'slide-' + bg );
			currentSlide.li.addClass( 'selected' );

			var showNext = function() {
				//alert("shownext"+ num);
				if( bg < currentSlide.backgrounds ) showSlide( num + 1, bg + 1 );
				else showSlide( ( num % slides.length ) + 1, 1 );
			};

			if( previousSlide != currentSlide ) {
				stopAnimation();
				/*currentSlide.content.fadeIn( fadeDuration);
				previousSlide.content.show().css( { 'z-index': 3 } );
				currentSlide.content.show().css( { 'z-index': 2 } );
				previousSlide.content.fadeOut( fadeDuration, function() {
					if( !timeout ) timeout = setTimeout( showNext, delay );
				} );*/
				currentSlide.content.fadeIn(fadeDuration, function() {
						previousSlide.content.fadeOut( fadeDuration/2, function() {
						if( !timeout ) timeout = setTimeout( showNext, delay );
					} );	
				} );
				
			} else {
				timeout = setTimeout( showNext, delay );
			}
		};
		timeout = setTimeout( function() { showSlide( 1, 1 ); }, 0 );

		$.each( slides, function( i ) {
			this.content.find( 'input,select' ).click( stopAnimation );
		} );
		}
		
		$.each( slides1, function( i ) {
			
			this.div
			.click( function( e ) { e.preventDefault(); setTimeout( function() { showSlide( i + 1, 1 ); }, 0 ); } )
			.css( { cursor: 'pointer' } )
			.find( 'a' )
			.click( function( e ) {
				e.stopPropagation();
				stopAnimation();
			} );
		} );
		
		} );
